/*eslint-disable*/
import api from '../'

class PointsHistoryApi {
    // GET: records
    static list(params, cancelToken = null) {
        return api.axios.get('/points-history', {params, cancelToken})
            .then(response => response.data)
    }

    static exportList(params) {
        return api.axios.get('/points-history/export', {params})
            .then(response => response.data)
    }
}

export default PointsHistoryApi;
